/**
 * Initializes a Wix search feature that expands the search box upon clicking the secondary menu,
 * and collapses it when the search box loses focus.
 *
 * @param {Object} $secondaryMenu - The secondary menu element.
 * @param {Object} $searchAppController - The search app controller element.
 * @param {Object} $searchBox - The search box element.
 * @returns {void}
 */

export function wixSearch($secondaryMenu, $searchAppController, $searchBox) {
    $secondaryMenu.on('wixSearchClick', event => {
        // const { isMobile } = event.data
        $searchAppController.expand()
        // $searchBox.focus()
        setTimeout(() => {
            $searchBox.focus()
        }, 100)
    })

    $searchBox.onBlur(event => {
        setTimeout(() => {
            $searchAppController.collapse()
        }, 500)
    })
}